import { InjectionToken } from '@angular/core';

export interface AssignmentResult {
	success: boolean;
	message?: string;
}

export interface ProjectAssignmentHandler {
	assignToProject(pointId: string): Promise<AssignmentResult>;
	removeFromProject(pointId: string): Promise<AssignmentResult>;
	canAssign(): boolean;
	canRemove(pointId: string): boolean;
	getAssignedPointIds(): Set<string>;
	deletePoint(pointId: string): Promise<AssignmentResult>;
	deletePoints(pointIds: string[]): Promise<AssignmentResult>;
}

export const PROJECT_ASSIGNMENT_HANDLER = new InjectionToken<ProjectAssignmentHandler>(
	'PROJECT_ASSIGNMENT_HANDLER'
);
